"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _default = exports["default"] = function _default(thickness) {
  return (0, _styledComponents.css)(["box-shadow:0 0 0 1px var(--border-color) ", ";"], thickness === '2px' ? ', inset 0 0 0 1px var(--border-color)' : '');
};
//# sourceMappingURL=createBorderCss.js.map